export const CREATE_TODOS = "CREATE_TODOS";
export const RETRIEVE_TODOS = "RETRIEVE_TODOS";
export const UPDATE_TODO = "UPDATE_TODO";
export const DELETE_TODO = "DELETE_TODO";
